import FAQData from "../Constant/FAQData";

const stripHTML = (html) => {
	const tmp = document.createElement("DIV");
	tmp.innerHTML = html;
	return tmp.textContent || tmp.innerText || "";
};

const FAQSchemaGenerator = ({ slug }) => {
	const data = FAQData[slug];
	if (!data) return null;

	const faqs = data.rows.map((faq) => ({
		"@type": "Question",
		name: stripHTML(faq.title),
		acceptedAnswer: {
			"@type": "Answer",
			text: stripHTML(faq.content),
		},
	}));

	return {
		"@context": "https://schema.org",
		"@type": "FAQPage",
		mainEntity: faqs,
	};
};

export default FAQSchemaGenerator;
